module.exports = __webpack_public_path__ + "img/right_4.12d9fb31.jpg";